import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "unit/:id",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "curriculum-maps" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
});
